export enum DermloopUserAffiliationDeleteReasonEnum {
  Inactive = 'Inactive',
  Expired = 'Expired',
  RemovedByUser = 'RemovedByUser',
  Other = 'Other',
}
